import { configOptions } from '../../helpers/axios';
import clientAxios from './../../config/axios';

export const getAllReturns = async (
  token: string,
  filter: string,
  pagination: any
): Promise<any> => {
  const filterTmp = filter ?? '';
  const complement = pagination.page
    ? `page=${pagination.page}&items_per_page=${pagination.rowsPerPage}${filterTmp}`
    : `all=1${filterTmp}`;
  const url = `/returns?country=${process.env.REACT_APP_ENV_COUNTRY}&${complement}`;
  const { data } = await clientAxios.get(url, configOptions(token));
  data.returns.map((item: any) => {
    item.complete_return_date = item.complete_return_date
      ? new Date(item.complete_return_date)
      : null;

    return item;
  });
  return data;
};
